var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-container"},[_c('vue-editor',{attrs:{"id":_vm.text},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }